/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";

import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import { submitSupportRequest } from "services/authProvider.js";

const styles = {
  form: {
    width: "100%",
    marginTop: 24
  },
  submit: {
    margin: "24px 0 16px"
  }
};

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        email: props.defaultEmail || "",
        message: ""
      },
      errorMessages: null,
      successMessage: null,
      isSubmitting: false
    };
  }

  handleChange = name => event => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: event.target.value
      }
    });
  };

  submitForm = e => {
    e.preventDefault();
    const { onSubmitSuccess, onSubmitError } = this.props;
    const { formData } = this.state;

    this.setState({
      isSubmitting: true,
      errorMessages: null,
      successMessage: null
    });

    submitSupportRequest(formData)
      .then(() => {
        this.setState({
          formData: {
            email: this.props.defaultEmail || "",
            message: ""
          },
          errorMessages: null,
          successMessage:
            "Your support request has been submitted! We will contact you soon.",
          isSubmitting: false
        });
        if (onSubmitSuccess) {
          onSubmitSuccess();
        }
      })
      .catch(() => {
        this.setState({
          errorMessages: [["Something went wrong! Please try again later."]],
          successMessage: null,
          isSubmitting: false
        });
        if (onSubmitError) {
          onSubmitError();
        }
      });
  };

  render() {
    const { classes, showTitle = true } = this.props;
    const {
      formData,
      errorMessages,
      successMessage,
      isSubmitting
    } = this.state;

    return (
      <form className={classes.form} noValidate onSubmit={this.submitForm}>
        <Grid container spacing={2}>
          {showTitle && (
            <Grid item xs={12}>
              <h3 style={{ margin: "0 0 16px 0" }}>Contact Us</h3>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              type="email"
              autoComplete="email"
              value={formData.email}
              onChange={this.handleChange("email")}
              disabled={isSubmitting}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              multiline
              rows={10}
              required
              fullWidth
              id="message"
              label="Message"
              name="message"
              value={formData.message}
              onChange={this.handleChange("message")}
              disabled={isSubmitting}
            />
          </Grid>
          <Grid item xs={12}>
            {errorMessages &&
              Object.keys(errorMessages).map(key => {
                const messages = errorMessages[key];
                return messages.map((message, idx) => {
                  return (
                    <SnackbarContent
                      message={message}
                      color="danger"
                      key={`error-${key}-${idx}`}
                    />
                  );
                });
              })}
          </Grid>
          <Grid item xs={12}>
            {successMessage && (
              <SnackbarContent message={successMessage} color="success" />
            )}
          </Grid>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={isSubmitting || !formData.email || !formData.message}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </form>
    );
  }
}

ContactForm.propTypes = {
  classes: PropTypes.object.isRequired,
  defaultEmail: PropTypes.string,
  showTitle: PropTypes.bool,
  onSubmitSuccess: PropTypes.func,
  onSubmitError: PropTypes.func
};

ContactForm.defaultProps = {
  defaultEmail: "",
  showTitle: true,
  onSubmitSuccess: null,
  onSubmitError: null
};

export default withStyles(styles)(ContactForm);
